(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6354],{

/***/ 56029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),

/***/ 53325:
/***/ (function(module) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),

/***/ 78084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9253);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46888);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3023);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75358);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14888);
/* harmony import */ var recharts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86108);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63850);
/* harmony import */ var views_Info_components_ChartLoaders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(265);
/* harmony import */ var state_swap_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68749);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68486);







var getChartColors = function(param) {
    var isChangePositive = param.isChangePositive;
    return isChangePositive ? {
        gradient1: "#00E7B0",
        gradient2: "#0C8B6C",
        stroke: "#31D0AA"
    } : {
        gradient1: "#ED4B9E",
        gradient2: "#ED4B9E",
        stroke: "#ED4B9E "
    };
};
var _obj;
var dateFormattingByTimewindow = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, state_swap_types__WEBPACK_IMPORTED_MODULE_3__/* .PairDataTimeWindowEnum.DAY */ .l.DAY, {
    hour: "2-digit",
    minute: "2-digit"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, state_swap_types__WEBPACK_IMPORTED_MODULE_3__/* .PairDataTimeWindowEnum.WEEK */ .l.WEEK, {
    month: "short",
    day: "2-digit"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, state_swap_types__WEBPACK_IMPORTED_MODULE_3__/* .PairDataTimeWindowEnum.MONTH */ .l.MONTH, {
    month: "short",
    day: "2-digit"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, state_swap_types__WEBPACK_IMPORTED_MODULE_3__/* .PairDataTimeWindowEnum.YEAR */ .l.YEAR, {
    month: "short",
    day: "2-digit"
}), _obj);
/**
 * Note: remember that it needs to be mounted inside the container with fixed height
 */ var LineChart = function(param) {
    var data = param.data, setHoverValue = param.setHoverValue, setHoverDate = param.setHoverDate, isChangePositive = param.isChangePositive, timeWindow = param.timeWindow;
    var ref = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)(), locale = ref.currentLanguage.locale;
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().theme;
    var colors = getChartColors({
        isChangePositive: isChangePositive
    });
    var dateFormatting = dateFormattingByTimewindow[timeWindow];
    if (!data || data.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Info_components_ChartLoaders__WEBPACK_IMPORTED_MODULE_2__/* .LineChartLoader */ .fn, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_6__/* .ResponsiveContainer */ .h, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(recharts__WEBPACK_IMPORTED_MODULE_7__/* .AreaChart */ .T, {
            data: data,
            margin: {
                top: 5,
                right: 0,
                left: 0,
                bottom: 5
            },
            onMouseLeave: function() {
                if (setHoverDate) setHoverDate(undefined);
                if (setHoverValue) setHoverValue(undefined);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "gradient",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "5%",
                                stopColor: colors.gradient1,
                                stopOpacity: 0.34
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "100%",
                                stopColor: colors.gradient2,
                                stopOpacity: 0
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_8__/* .XAxis */ .K, {
                    dataKey: "time",
                    axisLine: false,
                    tickLine: false,
                    tickFormatter: function(time) {
                        return time.toLocaleString(locale, dateFormatting);
                    },
                    minTickGap: 8
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_9__/* .YAxis */ .B, {
                    dataKey: "value",
                    axisLine: false,
                    tickLine: false,
                    domain: [
                        "auto",
                        "auto"
                    ],
                    hide: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_10__/* .Tooltip */ .u, {
                    cursor: {
                        stroke: theme.colors.textDisabled
                    },
                    contentStyle: {
                        display: "none"
                    },
                    formatter: function(tooltipValue, name, props) {
                        setHoverValue(props.payload.value);
                        setHoverDate(props.payload.time.toLocaleString(locale, {
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit"
                        }));
                        return null;
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(recharts__WEBPACK_IMPORTED_MODULE_11__/* .Area */ .u, {
                    dataKey: "value",
                    type: "linear",
                    stroke: colors.stroke,
                    fill: "url(#gradient)",
                    strokeWidth: 2
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LineChart);


/***/ })

}]);